// Customizable Area Start
import React, { Component } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import CustomButton from "./CustomButton.web";

const CustomDialog = styled(Dialog)({
  "& .MuiPaper-root": {
    borderRadius: "20px",
    width: "100%",
    maxWidth: "500px",
    padding: "65px 30px",
    position: "relative",
    "@media (max-width: 500px)": {
      padding: "35px",
    },
  },
});

const CustomDialogContent = styled(DialogContent)({
  padding: "0px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
});

const MainTitle = styled(Typography)({
  textAlign: "center",
  color: "#0F172A",
  fontSize: "1.75rem",
  fontWeight: 600,
  letterSpacing: "-0.12px",
  lineHeight: "32px",
  marginBottom: "15px",
  "@media (max-width: 500px)": {
    fontSize: "1.5rem",
  },
});

const SubTitle = styled(Typography)({
  textAlign: "center",
  color: "#64748B",
  fontSize: "1rem",
  fontWeight: 400,
  lineHeight: "22px",
  marginBottom: "30px",
  width: "65%",
  "@media (max-width: 500px)": {
    width: "100%",
    fontSize: "0.8rem",
  },
});

const CustomDialogActions = styled(DialogActions)({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  gap: "5px",
  padding: "0px",
});

interface Props {
  isOpen: boolean;
  title: string;
  subTitle: string;
  actionBtnTitle: string;
  cancelBtnTitle?: string;
  isActionLoading?: boolean;
  handleClose: () => void;
  handleAction: () => void;
}

export class CustomConfirmationDialog extends Component<Props> {
  scrollYPosition: number = 0;

  async componentDidUpdate(prevProps: Readonly<Props>): Promise<void> {
    const { isOpen } = this.props;

    if (prevProps.isOpen !== isOpen) {
      if (isOpen) {
        this.scrollYPosition = window.scrollY;
        document.body.style.position = "fixed";
        document.body.style.top = `-${this.scrollYPosition}px`;
        document.body.style.width = "100%";
      } else {
        setTimeout(() => {
          document.body.style.position = "";
          document.body.style.top = "";
          document.body.style.width = "";
          window.scrollTo(0, this.scrollYPosition);
        }, 300);
      }
    }
  }

  render() {
    const {
      isOpen,
      title,
      subTitle,
      actionBtnTitle,
      cancelBtnTitle = "Cancel",
      isActionLoading,
      handleClose,
      handleAction,
    } = this.props;
    return (
      <CustomDialog
        open={isOpen}
        onClose={handleClose}
        aria-labelledby="Confirmation Modal"
      >
        <CustomDialogContent>
          <MainTitle>{title}</MainTitle>
          <SubTitle>{subTitle}</SubTitle>
        </CustomDialogContent>
        <CustomDialogActions>
          <CustomButton
            data-test-id="action-btn"
            customVariant="filled"
            disabled={isActionLoading}
            isLoading={isActionLoading}
            onClick={handleAction}
          >
            {actionBtnTitle}
          </CustomButton>
          <CustomButton
            data-test-id="cancel-btn"
            customVariant="contained"
            disabled={isActionLoading}
            onClick={handleClose}
          >
            {cancelBtnTitle}
          </CustomButton>
        </CustomDialogActions>
      </CustomDialog>
    );
  }
}

export default CustomConfirmationDialog;
// Customizable Area End
